import React, {useContext} from 'react';
import {MyOrgMenu} from '../my-org/MyOrgMenu';
import {Route, Switch} from 'react-router-dom';
import {OrgInfo} from '../my-org/OrgInfo';
import {MyOrgInvoices} from '../my-org/MyOrgInvoices';
import {MyOrgPaymentSetup} from '../my-org/MyOrgPaymentSetup';
import {AppContext} from '../../context/app/appContext';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';
import { RadialGradient } from '@progress/kendo-drawing';


export const MyOrgPage = (props) => {

    const appContext = useContext(AppContext);

    return (
        <div id="app">
            <div id="content" style={{display: 'flex', height: '100vh'}}>
                <span style={{width: '10vw', height: '100vh'}}>
                    <Sidebar />
                </span>
                <span style={{width: '90vw', height: '100vh'}}>
                    <div style={{width: '100%', height: '10vh'}}>
                        <TopBar />
                    </div>
                    <div style={{width: '100%', height: '90vh', overflowY: 'scroll'}}>
                    <MyOrgMenu/>
                        <Switch>
                            <Route path="/account/payment-setup"><MyOrgPaymentSetup/></Route>
                            <Route path="/account/invoices"><MyOrgInvoices/></Route>
                            <Route path="/account"><OrgInfo organization={appContext.organization}/></Route>
                        </Switch>
                    </div>
                </span>
            </div>
        </div>
    );
};
